import { cn } from "../../lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      // The placeholder stands in for content that has not arrived, so it has
      // nothing to announce; `props` last leaves a caller free to say otherwise.
      aria-hidden="true"
      className={cn("animate-pulse rounded-md bg-stone-200", className)}
      {...props}
    />
  );
}

export { Skeleton };
